const trim = require('mn-utils/trim');
const formatTime = require('mn-utils/formatTime');
const get = require('mn-utils/get');

function asDoc(doc) {
  return doc ? {
    fileId: doc.id,
    name: doc.file_name || doc.id,
  } : null;
}
export function prepareItemForResponse(response) {
  const {
    birthday,
  } = response;
  return {
    ...response,
    fullname: response.full_name,
    birthday: birthday ? new Date(birthday) : birthday,
    countryOfResidence: response.country_of_residence,
    countryOfBirth: response.country_of_birth,
    passportOrNationId: response.document_type,
    docPassportOrNationalId: asDoc(response.document_identity),
    docProofOfAddress: asDoc(response.document_address),
  };
}


export function prepareItemForRequest(state) {
  const birthday = state.birthday;

  return {
    fullname: trim(state.fullname || ''),
    birthday: birthday && !isNaN(birthday)
      ? formatTime(birthday, '{yyyy}-{mm}-{dd}')
      : '',
    country_of_residence: trim(state.countryOfResidence || ''),
    country_of_birth: trim(state.countryOfBirth || ''),
    passport_or_nation_id: trim(state.passportOrNationId || ''),

    document_identity: get(state, 'docPassportOrNationalId.fileId'),
    document_address: get(state, 'docProofOfAddress.fileId'),
  };
}

function checkAge(birthday) { // birthday is a date
  var ageDifMs = Date.now() - birthday.getTime();
  var ageDate = new Date(ageDifMs); // miliseconds from epoch
  return Math.abs(ageDate.getUTCFullYear() - 1970) < 18;
}

export function prepareItem(state) {
  const invalidFullname = !trim(state.fullname);

  const invalidBirthday = !state.birthday || !Date.parse(state.birthday);
  const birthdayInFuture = !invalidBirthday
    ? new Date(state.birthday).getTime() > new Date().getTime()
    : false;
  const birthdayAboveEighteen = !invalidBirthday
    ? checkAge(state.birthday)
    : false;


  const invalidCountryOfResidence = !state.countryOfResidence;
  const invalidCountryOfBirth = !state.countryOfBirth;
  const invalidPassportOrNationId = !state.passportOrNationId;

  const invalidDocPassportOrNationalId = state.loadingDocPassportOrNationalId
    || !state.docPassportOrNationalId;
  const invalidDocProofOfAddress = state.loadingDocProofOfAddress
    || !state.docProofOfAddress;


  return {
    disabled: invalidFullname
      || invalidBirthday
      || birthdayInFuture
      || invalidCountryOfResidence
      || invalidCountryOfBirth
      || invalidPassportOrNationId
      || invalidDocPassportOrNationalId
      || invalidDocProofOfAddress,
    state,
    invalid: {
      fullname: invalidFullname,
      birthday: invalidBirthday,
      birthdayInFuture: birthdayInFuture,
      birthdayAboveEighteen: birthdayAboveEighteen,
      countryOfResidence: invalidCountryOfResidence,
      countryOfBirth: invalidCountryOfBirth,
      passportOrNationId: invalidPassportOrNationId,
      docPassportOrNationalId: invalidDocPassportOrNationalId,
      docProofOfAddress: invalidDocProofOfAddress,
    },
  };
}
